import { Layout } from '@morningtrain/react-crud'
import Section from 'layouts/page/Section'
import ContentWrap from 'layouts/page/ContentWrap'
import React from 'react'
import { Collection } from '@morningtrain/react-resources'
import { Column, Table } from '@morningtrain/react-columns'
import OperationFilters from 'layouts/crud/OperationFilters'
import Title from 'layouts/page/Title'
import * as Filters from '@morningtrain/react-filters'
import { MountSmartviewOnClick, MountSmartviewOnSelection } from '@morningtrain/react-smartviews'
import Button from 'ui/buttons/Button'
import { Link } from '@morningtrain/react-navigation'
import { Env } from '@morningtrain/helpers'
import TableWithHeaderWrap from 'ui/tables/TableWithHeaderWrap'
import TableScrollContainer from 'ui/tables/TableScrollContainer'
import SVGIcon from 'ui/helpers/SVGIcon'
import * as Errors from '@morningtrain/react-errors'
import WithSmartviewLayout from 'ui/layouts/WithSmartviewLayout'
import * as Auth from '@morningtrain/react-auth'

export default class SmartIndexLayout extends Layout {
  get operationName () {
    return this.crud.operationName ? this.crud.operationName : 'index'
  }

  get operationContext () {
    return this.props.operationContext || null
  }

  get smartview () {
    return this.props.smartview || null
  }

  get createSmartview () {
    return this.props.createSmartview || null
  }

  renderColumnActions () {
    const { actions } = this.props

    if (!actions) return null

    return (
      <Column>
        {actions}
      </Column>
    )
  }

  renderConstraints () {
    if (!this.props.constraints) {
      return null
    }

    return this.props.constraints
  }

  renderCreateAction () {
    const view = this.createSmartview

    if (view) {
      return (
        <MountSmartviewOnClick smartview={view}>
          <button className='icon-link mt-1'>
            <SVGIcon type='pencil' className='mr-2 h-4 w-4' />
            {this.props.createLabel}
          </button>
        </MountSmartviewOnClick>
      )
    }

    return (
      <Auth.Can permission={Env.get('page.route').replace('index', 'create')}>
        <Link route={Env.get('page.route').replace('index', 'create')} className='icon-link mt-1'>
          <SVGIcon type='pencil' className='mr-2 h-4 w-4' />
          {this.props.createLabel}
        </Link>
      </Auth.Can>
    )
  }

  renderFooter () {
    return (
      <div className='index-table-layout-footer border-t border-gray-200 px-6 py-8 sm:px-10'>
        {(this.props.footer) ? this.props.footer : (
          <Filters.PaginationFilter />
        )}
      </div>
    )
  }

  render () {
    return (
      <WithSmartviewLayout>
        <Collection resourceName={this.resourceName} operationName={this.operationName} operationContext={this.operationContext}>
          {this.renderConstraints()}

          {(!this.smartview) ? null : (
            <MountSmartviewOnSelection smartview={this.smartview} />
          )}

          <ContentWrap>

            <Section>

              <TableWithHeaderWrap>
                <div className='px-6 pt-10 pb-8 sm:flex sm:justify-between sm:items-center sm:pt-12 sm:px-10'>
                  <div>
                    <Title className='text-2xl' />
                    {this.renderCreateAction()}
                  </div>
                  <div className='flex mt-6 sm:mt-0'>
                    <OperationFilters filters={this.props.filters} />
                  </div>
                </div>

                <TableScrollContainer selectable={!!this.smartview}>
                  <Table selectOnClick>
                    {this.props.columns}
                    {this.renderColumnActions()}
                  </Table>
                </TableScrollContainer>

                {this.renderFooter()}

              </TableWithHeaderWrap>

            </Section>

          </ContentWrap>

        </Collection>
      </WithSmartviewLayout>
    )
  }
}
